import React from "react";
import { AutocompleteField, FormItem } from "@tiny/components";

interface DomainArrayInputProps {
  prefixName: string;
  disabled?: boolean;
}

const validateDomainName = (domain: string) => {
  const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+(\.[a-zA-Z0-9-_]+)+)$/;
  return domainRegex.test(domain);
};

function DomainArrayValue(props: DomainArrayInputProps) {
  const { prefixName, disabled } = props;
  const name = `${prefixName}.value.value`;

  return (
    <FormItem
      name={name}
      rules={{
        required: {
          value: true,
          message: "Required field",
        },
        validate: {
          value: (value: string[]) =>
            value.every(validateDomainName) || "Invalid domain name",
        },
      }}
      watchValue
    >
      <DomainArrayField disabled={disabled} />
    </FormItem>
  );
}

interface DomainArrayFieldProps {
  value?: string[];
  onChangeValue?: (value: string[]) => void;
  helperText?: string;
  error?: boolean;
  inputRef?: React.ForwardedRef<HTMLInputElement>;
  disabled?: boolean;
}

function DomainArrayField(props: DomainArrayFieldProps) {
  const { value, onChangeValue, helperText, error, inputRef, disabled } = props;
  const [internalValue, setInternalValue] = React.useState<string[]>(
    value || []
  );
  const [inputError, setInputError] = React.useState<string | null>(null);

  const changeValue = (v: string[]) => {
    if (v.every(validateDomainName)) {
      setInternalValue(v);
      setInputError(null);
      onChangeValue?.(v);
    } else {
      setInputError("One or more domain names are invalid.");
    }
  };

  return (
    <>
      <AutocompleteField
        inputRef={inputRef}
        placeholder={
          !(internalValue || value) || "Enter domain name and press Enter"
        }
        freeSolo
        multiple
        options={[]}
        value={internalValue || value}
        onChangeValue={changeValue}
        getOptionLabel={(option) => option}
        limitTags={1}
        helperText={inputError || helperText}
        error={error || !!inputError}
        showHelperTextMargin
        disabled={disabled}
      />
    </>
  );
}

export default DomainArrayValue;
